var React = require('react');

function InstantSearch (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Search"},React.createElement("g",{"id":"Vector"},[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9 14C12.0376 14 14.5 11.5376 14.5 8.5C14.5 5.46243 12.0376 3 9 3C5.96243 3 3.5 5.46243 3.5 8.5C3.5 11.5376 5.96243 14 9 14ZM9 16C13.1421 16 16.5 12.6421 16.5 8.5C16.5 4.35786 13.1421 1 9 1C4.85786 1 1.5 4.35786 1.5 8.5C1.5 12.6421 4.85786 16 9 16Z","fill":"black","fillOpacity":"0.7","key":0}),React.createElement("path",{"d":"M15 15.5L18.6721 21.5004C19.5045 22.7869 21.3112 22.9783 22.3947 21.8947C23.4783 20.8112 23.2869 19.0045 22.0004 18.1721L16 14.5L15 15.5Z","fill":"black","fillOpacity":"0.7","key":1})])));
}

InstantSearch.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = InstantSearch;

InstantSearch.default = InstantSearch;
